export default [
  'AAbs',
  'AL',
  'ALV',
  'AO',
  'CL',
  'CO',
  'DO',
  'EO',
  'HAL',
  'HALA',
  'HALP',
  'HALV',
  'HAOA',
  'HAOP',
  'HCL',
  'HCLA',
  'HCLP',
  'HDO',
  'HNPL',
  'HOC',
  'HOCA',
  'HOCP',
  'HPL',
  'HSD',
  'HSDA',
  'HSDP',
  'HSKA',
  'HSKL',
  'HSKP',
  'HSL',
  'HSLA',
  'HSLP',
  'ML',
  'NDD',
  'NPL',
  'O',
  'OC',
  'PH',
  'PL',
  'SD',
  'SH',
  'SKL',
  'SL',
  'WO',
];
